<template>
    <Box :title="'维修进程('+Total+'台)'" :SearchParams="IsSee" @SearchParams="IsSee=true">
        <LoadingFooter v-model="loading" :finished="finished" @load="onLoad" @scroll="IsSee=false">
            <div class="items" v-for="item in list" @click="$router.push({name: 'MaintenanceProgress', params: {item} })">
                <div>
                    <img src="@/assets/img/Icon_1.png" />
                    <div>
                        <div>
                            <span class="ellipsis">{{item.EquName}}</span>
                             <span class="ellipsis">{{item.Status}}</span>
                            <img src="../../assets/img/right.png" />
                        </div>
                        <div>
                            <div>
                                <p>资产编号：</p>
                                <p>规格型号：</p>
                                <p>使用科室：</p>
                            </div>
                            <div>
                                <p class="ellipsis">{{item.EquId}}</p>
                                <p class="ellipsis">{{item.Standard}}</p>
                                <p class="ellipsis">{{item.DepName}}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <span>维修日期</span>
                    <span>{{item.RepairDate}}</span>
                </div>
            </div>
        </LoadingFooter>
        <transition name="fade">
            <div class="menu" v-show="IsSee">
                <Field title="资产名称" placeholder="请输入编号或者名称" @onMessage="value => search.EquName = value" />
                <Field title="维修单号" placeholder="请输入" @onMessage="value => search.OrderNo = value" />
                <Field title="维修状态" placeholder="请选择" text="全部" :data="['全部','报修中','已响应','已接单(维修处理中)','审批中','审批未通过','已维修未验收','已验收','已忽略']"
                    type="popup" :selectIndex='0' @confirm="confirm(arguments[0])" />
                <Field title="使用科室" placeholder="请输入" @onMessage="value => search.KS = value" />
                <Field title="开始时间" placeholder="请选择" type="calendar" @onMessage="value => search.StartDate = value" />
                <Field title="结束时间" placeholder="请选择" type="calendar" @onMessage="value => search.EndDate = value" />
                <div class="search" @click="serach">查询</div>

            </div>
        </transition>
    </Box>
</template>

<script>
    import Box from '@/components/commonBox/commonBox'
    import Field from '../../components/field/field'
    import LoadingFooter from '../../components/loadingFooter/loadingFooter'
    export default {
        name: 'MaintenanceProgressList',
        data() {
            return {
                search: {
                    KS: null,
                    RepairStatus: '',
                    EquName: null,
                    OrderNo: null,
                    StartDate: null,
                    EndDate: null,
                },
                loading: true,
                finished: false,
                touchStartY: 0,
                Total: 0,
                IsSee: false,
                page: 1,
                list: [],
                RepairStatusArray: [{
                        id: '',
                        name: '全部',
                        color: '#FF9E48'
                    }, {
                        id: '1',
                        name: '报修中',
                        color: '#48A4FF'
                    }, {
                        id: '6',
                        name: '已响应',
                        color: '#4FA69E'
                    },
                    {
                        id: '5',
                        name: '已接单(维修处理中)',
                        color: '#EB5E5E'
                    }, {
                        id: '2',
                        name: '审批中',
                        color: '#56E0F3'
                    }, {
                        id: '0',
                        name: '审批未通过',
                        color: '#FF8040'
                    },
                    {
                        id: '3',
                        name: '已维修未验收',
                        color: '#4FA69E'
                    }, {
                        id: '4',
                        name: '已验收',
                        color: '#4FA69E'
                    }, {
                        id: '9',
                        name: '已忽略',
                        color: '#D4D4D4'
                    }
                ],
            }
        },
        components: {
            Box,
            Field,
            LoadingFooter
        },
        mounted() {
            this.loadDataDefault();
        },
        methods: {
            serach() {
                this.IsSee = false;
                this.list = [];
                this.page = 1;
                this.loadDataDefault();
            },
            onLoad() {
                if (!this.loading && !this.finished) {
                    this.page += 1;
                    this.loadDataDefault();
                }
            },
            loadDataDefault() {
                this.$post('api/Repair/OrderProList', {
                    Store: this.$UserInfo.StoreCode,
                    UserCode: this.$UserInfo.UserId,
                    StartDate: this.search.StartDate,
                    EndDate: this.search.EndDate,
                    DepNo: this.search.KS, //科室
                    OrderNo: this.search.OrderNo, //单号
                    EquName: this.search.EquName,
                    RepairStatus: this.search.RepairStatus,
                    PageIndex: this.page,
                    PageSize: 10
                }).then(result => {
                    console.log(result);
                    this.Total = result.Total;
                    for (let i = 0; i < result.OrderProList.length; i++) {
                        this.list.push(result.OrderProList[i]);
                    }
                    if (this.page * 10 >= this.Total) {
                        this.loading = false;
                        this.finished = true;
                    } else this.loading = false;
                })
            },
            confirm(obj) {
                const data = this.RepairStatusArray.find(x => x.name === obj);
                this.search.RepairStatus = data.id;
            }
        }
    }
</script>

<style scoped lang="scss">
    .menu {
        background: $BACKGROUND-COLOR;
        border-radius: 12px;
        padding: 0 29px 35px 40px;
        box-sizing: border-box;
        margin-bottom: 20px;

        .items {
            display: flex;
            height: 112px;
            align-items: center;
            border-bottom: 2px solid #F3F3F3;

            span {
                flex: 1;
            }

            input {
                width: 215px;
                font-size: 29px;
                text-align: center;

                &::-webkit-input-placeholder {
                    color: #858585;
                }
            }
        }

        .search {
            height: 88px;
            background: $THEME-COLOR;
            border-radius: 8px;
            font-size: 32px;
            color: $TEXT-LIGHT-COLOR;
            text-align: center;
            line-height: 88px;
            margin-top: 35px;
        }
    }

    .items {
        background: $BACKGROUND-COLOR;
        border-radius: 16px;
        margin-bottom: 20px;
        padding-bottom: 20px;

        &>div {
            &:first-child {
                display: flex;
                padding: 34px 16px 27px 26px;
                box-sizing: border-box;
                border-bottom: 2px solid #EFEFEF;

                img {
                    width: 150px;
                    height: 150px;
                    border-radius: 4px;
                }

                &>div {
                    &:nth-child(2) {
                        margin-left: 16px;
                        flex: 1;

                        &>div {
                            display: flex;

                            &:first-child {
                                margin-bottom: 18px;
                                display: flex;

                                span:first-child {
                                    color: $TEXT-DARK-COLOR;
                                    font-weight: bold;
                                    font-size: 32px;
                                    flex: 1;
                                    width: 208px;
                                }

                                span:nth-child(2) {
                                    color: $TEXT-DARK-COLOR;
                                    font-size: 28px;
                                    margin-left: 10px;
                                    width: 158px;
                                    text-align: right;
                                }

                                img {
                                    width: 32px;
                                    height: 32px;
                                    margin-left: 10px;
                                }
                            }

                            &:last-child {
                                p {
                                    color: #999;
                                    font-size: 26px;
                                    line-height: 45px;
                                    height: 45px;
                                }

                                &>div {
                                    &:last-child {
                                        p {
                                            width: 370px;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            &:last-child {
                margin-top: 16px;
                padding: 0 26px 0 31px;
                box-sizing: border-box;
                display: flex;

                span {
                    color: #999;
                    font-size: 26px;

                    &:first-child {
                        flex: 1
                    }
                }
            }
        }
    }

    .ColorClass {
        border-radius: 1em;
        text-align: center !important;
        color: #fff !important;
    }
</style>



// WEBPACK FOOTER //
// src/page/maintenanceProgressList/maintenanceProgressList.vue